<template>
	<div id="homepage">
		<heading></heading>
		<main :class="activeSectionClass">
			<cinemas></cinemas>
			<program></program>
			<detail></detail>
		</main>
		<LightboxTrailer/>
		<LightboxAbout/>
		<LightboxMobile/>
		<LightboxAdblock/>
	</div>
</template>

<script>
import store from '../store'
import Heading from '@/components/Heading'
import Cinemas from '@/components/Cinemas'
import Program from '@/components/Program'
import Detail from '@/components/Detail'
import LightboxTrailer from '@/components/lightbox/LightboxTrailer'
import LightboxAbout from '@/components/lightbox/LightboxAbout'
import LightboxMobile from '@/components/lightbox/LightboxMobile'
import LightboxAdblock from '@/components/lightbox/LightboxAdblock'

export default {
	store,
	components: {
		Heading,
		Cinemas,
		Program,
		Detail,
		LightboxTrailer,
		LightboxAbout,
		LightboxMobile,
		LightboxAdblock
	},
	computed: {
		activeSectionClass: function () {
			return `active--${this.$store.getters.activeSection.slug}`
		}
	},
	mounted: function () {
		const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent.substr(0, 4)) || window.innerWidth <= 720)
		const today = (new Date()).getTime()
		if (isMobile && localStorage.getItem('mobilePopup') - today <= 0) {
			document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-mobile')
		}
	}
}
</script>

<style lang="less">
	@import "../assets/less/default.less";
	@import "../assets/less/fonts.less";
	@import "../assets/less/vendors.less";
	@import "../assets/less/default/00-general.less";

	html, body, main { width: 100%; height: 100%; overflow: hidden; }
	body { .bgc(@red); }
	#homepage { height: 100vh; }

	main { display: flex; height: ~"calc(100% - 100px)";
		section { display: flex; flex-direction: column; position: relative; padding: 0 1em; min-width: 320px; border: 15px solid @redDark; border-top: 0;
			.top-left-dot();
			.top-right-dot();

			@headerHeight: 80px;
			header { width: 100%; height: 80px; border-bottom: 1px dashed fade(#fff, 40);
				h2 { width: 100%; font-size: 32/15rem; text-align: center; letter-spacing: 5px; line-height: @headerHeight; }
			}
			.content-wrapper { position: relative; overflow: hidden; overflow-y: scroll; height: auto;
				&:after { .bottom-left(-2px); position: sticky; display: block; content: ''; width: 100%; height: 10%; background: linear-gradient(to bottom,rgba(0,0,0,0) 0%, rgba(218, 60, 60, .9) 100%); }
				&::-webkit-scrollbar {
					width: 4px;
				}
				&::-webkit-scrollbar-track {
					background-color: @red;
				}
				&::-webkit-scrollbar-thumb {
					background-color: rgba(0, 0, 0, .5);
					border-radius: 4px;
				}
			}
		}
	}

	@media @tablet {
		html, body { overflow: hidden; }
		main { transition: left 1s ease, right 1s ease;position: relative; width: 150vw; left: -50vw;
			&.active--cinemas { left: 0vw;
				section#program { border-left-width: 0px; border-right: 15px solid @redDark; }
			}
			&.active--program { left: -50vw; }
			&.active--detail { left: -50vw; }
		}
	}

	@media @mobile {
		html, body { overflow: hidden; }
		main { position: relative; width: 300vw; height: 80%; transition: left 1s ease, right 1s ease;
			&.active--cinemas { left: 0; }
			&.active--program { left: -100vw; }
			&.active--detail { left: -200vw; }
			section {
				&:before { display: none; }
				&:after { display: none; }
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/Homepage.vue